import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MessageListContainerComponent } from '../../containers/message-list-container/message-list-container.component';

@UntilDestroy()
@Component({
  selector: 'pc-messages-page',
  standalone: true,
  imports: [
    TranslocoModule,
    MatCardModule,
    MatSidenavModule,
    MatButtonModule,
    MatExpansionModule,
    MessageListContainerComponent
  ],
  templateUrl: './messages-page.component.html',
  styleUrls: ['./messages-page.component.scss']
})
export class MessagesPageComponent {}
